import React from "react"
import { Card, CardContent, Typography, Box, Divider } from "@mui/material"
import OverviewCardSkeleton from "./OverviewCardSkeleton"

const OverviewCard = ({ title, description, stats, loading = false }) => {
  if (loading) {
    return <OverviewCardSkeleton />
  }
  return (
    <Card
      sx={{
        minWidth: "100%",
        height: "208px",
        flexShrink: 0,
        padding: 0,
        boxShadow: "none",
        border: "1px solid #E5E9EC",
        borderRadius: "8px",
      }}
    >
      <CardContent
        sx={{
          padding: 0,
          height: "100%",
          display: "flex",
          flexDirection: "column",
          "&:last-child": { paddingBottom: 0 },
        }}
      >
        <Box sx={{ padding: "16px 24px 16px 24px" }}>
          <Typography
            sx={{
              color: "#061522",
              fontFamily: "Inter",
              fontSize: "16px",
              fontWeight: 500,
              lineHeight: "18px",
              marginBottom: "8px",
            }}
          >
            {title}
          </Typography>

          <Typography
            sx={{
              color: "#405261",
              fontFamily: "Inter",
              fontSize: "12px",
              fontWeight: 400,
              lineHeight: "18px",
            }}
          >
            {description}
          </Typography>
        </Box>

        <Divider
          sx={{
            borderColor: "#E5E9EC",
            width: "100%",
          }}
        />

        <Box
          sx={{
            padding: "16px 24px 24px 24px",
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            gap: "14px",
          }}
        >
          {stats.map((stat, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  color: "#405261",
                  fontFamily: "Inter",
                  fontSize: "14px",
                  fontWeight: 400,
                  lineHeight: "18px",
                }}
              >
                {stat.label}
              </Typography>
              <Typography
                sx={{
                  color: "#061522",
                  textAlign: "right",
                  fontFamily: "Inter",
                  fontSize: "14px",
                  fontWeight: 500,
                  lineHeight: "18px",
                }}
              >
                {stat.value}
              </Typography>
            </Box>
          ))}
        </Box>
      </CardContent>
    </Card>
  )
}

export default OverviewCard
